window.onload = function () {
  const form = document.getElementById("klaviyo-subscribe-form");
  if (!form) {
    console.error("❌ Form not found");
    return;
  }

  console.log("✅ Klaviyo form loaded and ready");

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const email = form.email.value.trim();
    console.log("📤 Sending email to Klaviyo:", email);

    if (!email) {
      alert("Please enter your email.");
      return;
    }

    try {
      const payload = {
        data: {
          type: "subscription",
          attributes: {
            list_id: "MqPyTM",
            email: email,
            custom_source: "Website Footer",
            api_key: "LepJCr"
          }
        }
      };

      console.log("📦 Payload being sent:", payload);

      const response = await fetch("https://a.klaviyo.com/api/subscribe", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-05-15"
        },
        body: JSON.stringify(payload)
      });

      console.log("📥 Raw response object:", response);

      if (response.ok) {
        form.reset();
        alert("✅ Subscription successful!");
        const success = document.getElementById("klaviyo-subscribe-success");
        if (success) {
          success.style.display = "block";
        }
      } else {
        const errText = await response.text();
        alert("❌ Error from Klaviyo");
        console.error("❌ Klaviyo error body:", errText);
      }
    } catch (err) {
      console.error("❌ JavaScript runtime error:", err);
      alert("❌ Network/JS error");
    }
  });
};
